import type { FormConfig } from "@/cms/models";

export type SchedulingFormType = "assessment" | "viewing";

export function showFormDateTimeFields(
  forms: FormConfig | undefined,
  form: SchedulingFormType,
): boolean {
  return forms?.[form]?.showDateTimeFields !== false;
}
